<template>
  <div class="table_head table_head_filter">
    <div class="flex flex_between">
      <div>
        <md-button class="md-blank margin_r" @click="showCsvReportModal(true)">
          <i class="fa fa-cogs btn_icon" aria-hidden="true"></i>
          {{ $t("allReceivables.head.csv") }}
        </md-button>
        <md-button class="md-blank" @click="showDownloadDocumentsModal(true)">
          <i class="fa fa-paperclip btn_icon" aria-hidden="true"></i>
          {{$t('allReceivables.head.download')}}
        </md-button>
      </div>
    </div>
    <AllReceivablesCsvReportModal
            v-if="csvReportModalShown"
            @close="showCsvReportModal(false)"
    ></AllReceivablesCsvReportModal>
    <AllReceivablesDownloadAssignmentDocumentsModal
            v-if="downloadDocumentsModalShown"
            @close="showDownloadDocumentsModal(false)"
      ></AllReceivablesDownloadAssignmentDocumentsModal>
  </div>
</template>
<script>
import AllReceivablesCsvReportModal from "@/components/templates/seller/receivables/AllReceivablesCsvReportModal";
import AllReceivablesDownloadAssignmentDocumentsModal
  from "@/components/templates/seller/receivables/AllReceivablesDownloadAssignmentDocumentsModal";

export default {
  components: {
    AllReceivablesCsvReportModal,
    AllReceivablesDownloadAssignmentDocumentsModal
  },
  data() {
    return {
      csvReportModalShown: false,
      downloadDocumentsModalShown: false,
      iconList: [
        { type: "del", iconName: "fa-trash", colorName: "secondary_color" },
        { type: "share", iconName: "fa-paper-plane", colorName: "accent_color" }
      ]
    };
  },
  methods: {
    showCsvReportModal(value) {
      this.csvReportModalShown = value;
    },
    showDownloadDocumentsModal(value) {
      this.downloadDocumentsModalShown = value;
    }
  }
};
</script>
